// src/pages/AdminPayoutPage.jsx
// Dashboard propriétaire : voir et virer les revenus PayChat

import { useEffect, useState } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';

const C = {
  bg: '#0A0E1A', surface: '#111827', card: '#1a2235',
  border: '#1e2d45', accent: '#00D4AA', gold: '#F5C542',
  purple: '#7C3AED', blue: '#0EA5E9', red: '#FF4F6A',
  text: '#E8EDF5', muted: '#6b7fa3',
};

const fmt = (n) => parseFloat(n || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function AdminPayoutPage() {
  const [data, setData]         = useState(null);
  const [loading, setLoading]   = useState(true);
  const [payoutAmt, setPayoutAmt] = useState('');
  const [payoutNote, setPayoutNote] = useState('');
  const [processing, setProcessing] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin/wallet');
      setData(res.data);
    } catch { toast.error('Accès admin requis'); }
    finally { setLoading(false); }
  };

  const handlePayout = async () => {
    if (!payoutAmt || parseFloat(payoutAmt) < 1) return toast.error('Montant minimum: 1FCFA ');
    setProcessing(true);
    try {
      const res = await api.post('/admin/payout', {
        amount: parseFloat(payoutAmt),
        note:   payoutNote || 'Virement revenus PayChat',
      });
      toast.success(res.message);
      setPayoutAmt('');
      setPayoutNote('');
      setShowConfirm(false);
      loadData();
    } catch (err) {
      toast.error(err.error || 'Erreur lors du virement');
    } finally { setProcessing(false); }
  };

  if (loading) return (
    <div style={{ minHeight:'100vh', background:C.bg, display:'flex', alignItems:'center', justifyContent:'center', color:C.muted, fontFamily:"'Sora', sans-serif" }}>
      Chargement...
    </div>
  );

  const w = data?.wallet || {};
  const monthlyData = data?.monthly_breakdown || [];
  const payouts = data?.recent_payouts || [];
  const subRevenue = data?.subscription_revenue || 0;

  return (
    <div style={{ minHeight:'100vh', background:C.bg, fontFamily:"'Sora', sans-serif", color:C.text }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&display=swap'); *{box-sizing:border-box}`}</style>

      <div style={{ background:C.surface, borderBottom:`1px solid ${C.border}`, padding:'16px 32px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <div>
          <div style={{ fontSize:20, fontWeight:800, color:C.accent }}>💰 Mes Revenus PayChat</div>
          <div style={{ fontSize:12, color:C.muted }}>Wallet plateforme & virements</div>
        </div>
        <button onClick={loadData} style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:8, padding:'8px 16px', cursor:'pointer', color:C.muted, fontSize:13, fontFamily:"'Sora', sans-serif" }}>
          Actualiser
        </button>
      </div>

      <div style={{ maxWidth:1100, margin:'0 auto', padding:'32px 24px' }}>

        {/* Solde principal */}
        <div style={{
          background:'linear-gradient(135deg, #003d2e, #001a14)',
          border:`2px solid ${C.accent}55`, borderRadius:24, padding:'36px 40px',
          marginBottom:32, boxShadow:`0 0 60px ${C.accent}22`,
          display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:24,
        }}>
          <div>
            <div style={{ fontSize:12, color:C.accent, fontWeight:700, letterSpacing:2, textTransform:'uppercase', marginBottom:8 }}>
              Solde disponible à virer
            </div>
            <div style={{ fontSize:64, fontWeight:800, color:C.text, letterSpacing:'-3px', lineHeight:1 }}>
              FCFA {fmt(w.balance)}
            </div>
            <div style={{ fontSize:13, color:C.muted, marginTop:12 }}>
              Total collecté depuis le début : <span style={{ color:C.accent, fontWeight:700 }}>FCFA {fmt(w.total_collected)}</span>
            </div>
            {w.last_payout_at && (
              <div style={{ fontSize:12, color:C.muted, marginTop:6 }}>
                Dernier virement : FCFA {fmt(w.last_payout_amt)} le {new Date(w.last_payout_at).toLocaleDateString('fr-FR')}
              </div>
            )}
          </div>

          {/* Bouton virement */}
          <div style={{ minWidth:260 }}>
            {!showConfirm ? (
              <div>
                <div style={{ fontSize:11, color:C.muted, fontWeight:600, letterSpacing:1, textTransform:'uppercase', marginBottom:8 }}>VIRER VERS MON COMPTE</div>
                <div style={{ display:'flex', gap:8, marginBottom:12, flexWrap:'wrap' }}>
                  {[50, 100, 500, 'Tout'].map(a => (
                    <button key={a} onClick={() => setPayoutAmt(a === 'Tout' ? String(parseFloat(w.balance).toFixed(2)) : String(a))} style={{
                      padding:'6px 14px', borderRadius:8, border:`1px solid ${C.border}`,
                      background: String(payoutAmt) === (a === 'Tout' ? String(parseFloat(w.balance).toFixed(2)) : String(a)) ? `${C.accent}22` : C.card,
                      color:C.accent, fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:"'Sora', sans-serif",
                    }}>{a === 'Tout' ? 'Tout virer' : `FCFA ${a}`}</button>
                  ))}
                </div>
                <input type="number" value={payoutAmt} onChange={e => setPayoutAmt(e.target.value)}
                  placeholder="Montant (FCFA )" min="1"
                  style={{ width:'100%', background:C.card, border:`1px solid ${C.border}`, borderRadius:10, padding:'10px 14px', color:C.text, fontSize:15, fontFamily:"'Sora', sans-serif", outline:'none', marginBottom:8, boxSizing:'border-box' }} />
                <input value={payoutNote} onChange={e => setPayoutNote(e.target.value)}
                  placeholder="Note (optionnel)"
                  style={{ width:'100%', background:C.card, border:`1px solid ${C.border}`, borderRadius:10, padding:'10px 14px', color:C.text, fontSize:13, fontFamily:"'Sora', sans-serif", outline:'none', marginBottom:12, boxSizing:'border-box' }} />
                <button onClick={() => { if(payoutAmt) setShowConfirm(true); }} style={{
                  width:'100%', padding:'12px', background:`linear-gradient(90deg, ${C.accent}, #00b894)`,
                  border:'none', borderRadius:12, cursor:'pointer', color:'#000',
                  fontWeight:800, fontSize:14, fontFamily:"'Sora', sans-serif",
                }}>
                  Virer FCFA {payoutAmt || '0'} sur mon compte
                </button>
              </div>
            ) : (
              <div style={{ background:C.card, border:`1px solid ${C.gold}44`, borderRadius:16, padding:'20px' }}>
                <div style={{ fontSize:14, fontWeight:700, color:C.gold, marginBottom:12 }}>⚠️ Confirmer le virement</div>
                <div style={{ fontSize:13, color:C.muted, marginBottom:16, lineHeight:1.6 }}>
                  Vous allez virer <span style={{ color:C.accent, fontWeight:800 }}>FCFA {payoutAmt}</span> vers votre compte bancaire (compte Stripe Connect configuré).<br/>
                  Délai : 1-2 jours ouvrés.
                </div>
                <div style={{ display:'flex', gap:8 }}>
                  <button onClick={() => setShowConfirm(false)} style={{ flex:1, padding:'10px', background:'transparent', border:`1px solid ${C.border}`, borderRadius:10, cursor:'pointer', color:C.muted, fontFamily:"'Sora', sans-serif" }}>
                    Annuler
                  </button>
                  <button onClick={handlePayout} disabled={processing} style={{ flex:2, padding:'10px', background:`linear-gradient(90deg, ${C.accent}, #00b894)`, border:'none', borderRadius:10, cursor:'pointer', color:'#000', fontWeight:800, fontFamily:"'Sora', sans-serif" }}>
                    {processing ? 'Traitement...' : '✓ Confirmer le virement'}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Revenus mensuels */}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:24, marginBottom:24 }}>

          {/* Tableau mensuel */}
          <div style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:16, padding:'24px' }}>
            <div style={{ fontSize:15, fontWeight:700, marginBottom:16 }}>Revenus par mois</div>
            {monthlyData.length === 0 && (
              <div style={{ color:C.muted, fontSize:13, textAlign:'center', padding:'20px 0' }}>
                Aucune transaction pour le moment
              </div>
            )}
            {monthlyData.map((m, i) => (
              <div key={i} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'10px 0', borderBottom:`1px solid ${C.border}` }}>
                <div>
                  <div style={{ fontSize:13, fontWeight:600 }}>
                    {new Date(m.month).toLocaleDateString('fr-FR', { month:'long', year:'numeric' })}
                  </div>
                  <div style={{ fontSize:11, color:C.muted }}>{parseInt(m.transaction_count)} transactions · FCFA {fmt(m.volume)} volume</div>
                </div>
                <div style={{ textAlign:'right' }}>
                  <div style={{ fontSize:16, fontWeight:800, color:C.accent }}>FCFA {fmt(m.fees_collected)}</div>
                  <div style={{ fontSize:10, color:C.muted }}>taux effectif: {parseFloat(m.effective_rate || 1).toFixed(2)}%</div>
                </div>
              </div>
            ))}
            {subRevenue > 0 && (
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'10px 0', background:`${C.purple}11`, borderRadius:8, paddingLeft:12, marginTop:8 }}>
                <div style={{ fontSize:13, color:C.purple, fontWeight:600 }}>Abonnements (mois en cours)</div>
                <div style={{ fontSize:16, fontWeight:800, color:C.purple }}>FCFA {fmt(subRevenue)}</div>
              </div>
            )}
          </div>

          {/* Historique virements */}
          <div style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:16, padding:'24px' }}>
            <div style={{ fontSize:15, fontWeight:700, marginBottom:16 }}>Derniers virements</div>
            {payouts.length === 0 && (
              <div style={{ color:C.muted, fontSize:13, textAlign:'center', padding:'20px 0' }}>
                Aucun virement effectué
              </div>
            )}
            {payouts.map((p, i) => (
              <div key={i} style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:10, padding:'12px 16px', marginBottom:10 }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <div>
                    <div style={{ fontSize:14, fontWeight:700, color:C.text }}>FCFA {fmt(p.amount)}</div>
                    <div style={{ fontSize:11, color:C.muted, marginTop:2 }}>{p.note}</div>
                    <div style={{ fontSize:10, color:C.muted, marginTop:2 }}>
                      {new Date(p.created_at).toLocaleDateString('fr-FR')}
                    </div>
                  </div>
                  <div style={{
                    fontSize:11, padding:'4px 10px', borderRadius:8, fontWeight:700,
                    background: p.status === 'completed' ? '#00d4aa22' : '#f5c54222',
                    color: p.status === 'completed' ? C.accent : C.gold,
                  }}>
                    {p.status === 'completed' ? '✓ Reçu' : p.status === 'processing' ? '⏳ En cours' : p.status}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Note explicative */}
        <div style={{ background:`${C.blue}11`, border:`1px solid ${C.blue}44`, borderRadius:16, padding:'20px 24px' }}>
          <div style={{ fontSize:13, fontWeight:700, color:C.blue, marginBottom:10 }}>ℹ️ Comment fonctionnent vos revenus ?</div>
          <div style={{ fontSize:12, color:C.muted, lineHeight:1.8 }}>
            <strong style={{ color:C.text }}>1% de commission</strong> est prélevé automatiquement sur chaque transaction entre utilisateurs PayChat et crédité instantanément sur ce wallet plateforme.<br/>
            <strong style={{ color:C.text }}>Les abonnements</strong> (Premium, Business, etc.) sont prélevés par Stripe et versés directement sur votre compte bancaire tous les 2 jours ouvrés.<br/>
            <strong style={{ color:C.text }}>Les recharges voucher</strong> génèrent une marge selon le prix de vente aux revendeurs vs la valeur nominale.<br/>
            <strong style={{ color:C.text }}>Pour virer les commissions</strong>, utilisez le bouton ci-dessus — les fonds arrivent en 1-2 jours ouvrés via Stripe Payout.
          </div>
        </div>
      </div>
    </div>
  );
}
